// extracted by mini-css-extract-plugin
module.exports = {"trackingPrice":"PostViewTrackingPrice-module__trackingPrice","isCancelled":"PostViewTrackingPrice-module__isCancelled","fullypaid":"PostViewTrackingPrice-module__fullypaid"};